var hamburgQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zur Freien und Hansestadt Hamburg?',
    image: '351',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '302',
    question: 'Welches ist ein Bezirk von Hamburg?',
    answers: [
      {
        content: 'Altona',
        key: 1,
      },
      {
        content: 'Hemelingen',
        key: 0,
      },
      {
        content: 'Pankow',
        key: 0,
      },
      {
        content: 'Demmin',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird das Landesparlament in Hamburg gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Hamburg bei Kommunalwahlen (Wahl der Bezirksversammlungen) wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Hamburg?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'weiß-rot',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Hamburg über politische Themen informieren?',
    answers: [
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '307',
    question: 'Welches Bundesland ist ein Stadtstaat?',
    answers: [
      {
        content: 'Hamburg',
        key: 1,
      },
      {
        content: 'Sachsen',
        key: 0,
      },
      {
        content: 'Bayern',
        key: 0,
      },
      {
        content: 'Thüringen',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Hamburg?',
    image: '358',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin des Stadtstaates Hamburg?',
    answers: [
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 0,
      },
      {
        content: 'Erster Bürgermeister / Erste Bürgermeisterin',
        key: 1,
      },
      {
        content: 'Regierender Senator / Regierende Senatorin',
        key: 0,
      },
      {
        content: 'Oberbürgermeister / Oberbürgermeisterin',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
  {
    id: '310',
    question: 'Welchen Senator / welche Senatorin hat Hamburg nicht?',
    answers: [
      {
        content: 'Justizsenator / Justizsenatorin',
        key: 0,
      },
      {
        content: 'Senator / Senatorin für Außenbeziehungen',
        key: 1,
      },
      {
        content: 'Finanzsenator / Finanzsenatorin',
        key: 0,
      },
      {
        content: 'Innensenator / Innensenatorin',
        key: 0,
      },
    ],
    category: 'Hamburg',
  },
]

export default hamburgQuestions
